
const routes = [
  {
    path: "/my-account",
    name: "my-account",
    component: () => import(/* webpackChunkName: "Account" */ "./views/accountPage.vue"),
    props: route => Object.assign({}, route.query, route.params),
  },
];
export default routes;
